import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { EntityQuery } from 'breeze-client';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { confirm, alert } from 'devextreme/ui/dialog';
import _ from 'lodash';
import moment from 'moment';
import { AppInformationService, AuthService, GenesisUnitOfWork, ReportService } from 'app/core/core.module';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { AssemblySchedule, OrderLineDetail } from 'app/core/model/entity-model';

@Component({
    selector: 'app-build-list',
    templateUrl: './build-list.component.html',
    styleUrls: ['./build-list.component.scss'],
    standalone: false
})
export class BuildListComponent implements OnInit {
    jigs: any;
    orderLineDetails: any;
    filter: any;
    productions: any = [];
    showAsDialog = false;
    priorities = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    schedules: any;
    processing = false;
    allowReordering = false;
    showCompleted = false;
    today: Date;
    dayCalcs: any;
    colors: any;
    canEditGrid = false as boolean;
    isReadyOnly = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    @ViewChild('productionsGrid') productionsGrid: DxDataGridComponent;

    constructor(
        private uow: GenesisUnitOfWork,
        public auth: AuthService,
        private appInfo: AppInformationService,
        private report: ReportService,
        private modalService: BsModalService,
        private router: Router
    ) {}

    async ngOnInit() {
        const deliveryOptions = this.uow.lookups.deliveryOptions;
        this.canEditGrid = this.auth.hasRole('OrdersAdmin');
        const dealers = await this.uow.dealers.all();

        // this.colors = this.uow.lookups.productionColors;
        this.jigs = await this.uow.assemblyJigs.all();
        this.filter = {};
        this.filter.runDate = new Date();
        this.today = new Date();
        this.filter.jigId = 1;
        this.appInfo.title = `Assembly Setup - ${moment(this.today).format('MM/DD/YYYY')}`;
        await this.getData();
        await this.getSchedules();
    }

    async getData(showCompleted?: boolean) {
        this.orderLineDetails = (await this.uow.getActiveOrderBuildDetail(['orderLine.order', 'notes.createdBy'])) as OrderLineDetail[];
    }

    async getSchedules() {
        this.schedules = (await this.uow.getProductionSchedule(this.filter.jigId, this.filter.runDate, ['orderLineDetail.orderLine.order.dealer'])) as AssemblySchedule[];
        console.log(this.schedules);
        if (Number(this.filter.priority) === 1) {
            let orderLineId = null;
            let index = 0;
            let count = 0;
            // _.sortBy(this.schedules, 'orderLineId').forEach((x) => {
            //     if (count === 0) orderLineId = x.orderLineId;
            //     if (x.orderLineId !== orderLineId) {
            //         orderLineId = x.orderLineId;
            //         index++;
            //     }
            //     x.color = this.colors[index];
            //     count++;
            // });
            await this.uow.commit();
        }
    }

    selectionChange(e) {}

    async prioritySelectionChange(e) {
        await this.getSchedules();
        this.setPermissions();
    }

    async priorityChange(offset: number) {
        this.appInfo.pleaseWaitShow();
        this.filter.priority += offset;
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async dateChange(offset: number) {
        this.appInfo.pleaseWaitShow();
        this.filter.runDate = moment(this.filter.runDate).add(offset, 'days').toDate();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async rowDoubleClick(e) {
        this.addToProduction(e.data);
    }

    async open(orderId: number) {
        this.router.navigate(['/sales-orders/' + (!!orderId ? orderId : 'new')]);
    }

    delete() {}

    setPermissions() {
        this.allowReordering = !!this.filter.runDate && moment(this.filter.runDate).endOf('day') > moment(this.today).startOf('day');
    }
    async onRowUpdating(e, grid) {
        await grid.instance.saveEditData();
        await this.uow.commit();
    }

    rowPrepareProduction(e) {
        if (e.rowType === 'data') {
            if (!!e.data.completed) {
                e.rowElement.className = e.rowElement.className + ' production-gray-grid';
            }
        }
    }

    rowPrepare(e) {
        if (e.rowType === 'data') {
            // if (!!e.data.order.color) e.rowElement.style.backgroundColor = `${e.data.order.color}`;
            if (!!e.data.deleted) {
                e.rowElement.className = e.rowElement.className + ' production-gray-grid';
            }
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtonsBefore',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                location: 'after',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }
    onSecondaryToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    async toggleCompleted() {
        this.showCompleted = !this.showCompleted;
        await this.getData(this.showCompleted);
    }

    async print() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows || selectedRows.length === 0) return;

        this.filter.ids = selectedRows.map(x => {
            return x.id;
        })
        // console.log('filter', this.filter);
        // if (!this.filter.runDate) return;
        await this.report.printAssemblySchedule({ids: this.filter.ids});
    }

    async addToProduction(row: any) {
        if (this.processing) return;
        this.processing = true;
        // if (row.remainingQty === 0) {
        //     await alert('Selected orderline has a remaining qty of 0', `${this.appInfo.settings.company}`);
        //     this.processing = false;
        //     return;
        // }

        // if (!(await this.similarProductOrderLinesCheckOk(row))) {
        //     this.processing = false;
        //     return;
        // }

        this.appInfo.pleaseWaitShow();
        const assemblySchedule = this.uow.assemblySchedules.createEntity() as AssemblySchedule;
        assemblySchedule.orderLineDetailId = row.id;
        assemblySchedule.created = new Date();
        assemblySchedule.createdBy = this.auth.currentUser.userName;
        // assemblySchedule.displayOrder = !!this.schedules ? this.schedules.length + 1 : 1;
        assemblySchedule.jigId = this.filter.jigId;
        assemblySchedule.buildDate = this.filter.runDate;
        await this.uow.commit();
        await this.getSchedules();
        this.appInfo.pleaseWaitHide();
        this.processing = false;
    }


    async removeProduction(row: any) {

        row.entityAspect.setDeleted();
        await this.uow.commit();
        await this.getSchedules();
    }

    async productionRowDoubleClick(e) {
        this.addToProduction(e.data);
    }

    async completePartial() {
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Partial OrderLine',
                dialogPrompt: 'Enter New Total Number of Completed Cases',
                checkNumeric: true,
                checkInteger: true,
                minValue: 1,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result && result.success) {
                await this.complete(result.value);
            }
            modalRef.hide();
        });
    }

    async complete(quantity?: any) {
        if (this.processing) return;
        this.processing = true;

        const selectedRows = this.productionsGrid.instance.getSelectedRowsData();
        if (!selectedRows || selectedRows.length === 0) return;

        this.appInfo.pleaseWaitShow();
        const today = new Date();
        const uniqueSchedules = _.uniqBy(selectedRows, 'orderLineId');

        for (let index = 0; index < uniqueSchedules.length; index++) {
            if (!uniqueSchedules[index].completed) {
                // const orderLine = uniqueSchedules[index].orderLine as OrderLine;

                // const production = this.uow.orderLineProductions.createEntity() as OrderLineProduction;
                // production.created = today;
                // production.createdById = this.auth.currentUser.id;
                // production.orderLineId = orderLine.id;
                // production.quantity = quantity ? quantity - orderLine.completedQty : orderLine.remainingQty;

                // production.julianDate = moment(today).dayOfYear();
                // production.bestBeforeDate = moment(today)
                //     .add(orderLine.bestBeforeNumber - 1, 'days')
                //     .toDate();
                // production.sellByDate = moment(today)
                //     .add(orderLine.sellByNumber - 1, 'days')
                //     .toDate();
                // const orderLines = (await this.uow.orders.getProductionScheduleByOrderLineId(orderLine.id, this.filter.priority, this.filter.runDate)) as any;
                // orderLines.forEach((line) => {
                //     line.completed = today;
                // });
            }
        }

        selectedRows.forEach(row => {
            row.completed = new Date();
            row.completedBy = this.auth.currentUser.userName;
        });

        await this.uow.commit();
        await this.getSchedules();
        this.appInfo.pleaseWaitHide();
        this.productionsGrid.instance.clearSelection();
        this.processing = false;
    }

    onReorder = async (e) => {
        console.log(this.schedules);
        var visibleRows = e.component.getVisibleRows(),
            toIndex = this.schedules.indexOf(visibleRows[e.toIndex].data),
            fromIndex = this.schedules.indexOf(e.itemData);

        this.schedules.splice(fromIndex, 1);
        this.schedules.splice(toIndex, 0, e.itemData);

        this.updateDisplayOrder(this.schedules);
        this.sortPartOptions(this.schedules);
        await this.uow.commit();
    };

    updateDisplayOrder(rows: any[]) {
        rows.forEach((row, index) => {
            if (row.lane !== index + 1) row.lane = index + 1;
        });
    }
    sortPartOptions(rows: any[]) {
        rows.sort((a, b) => (a.lane || 9999) - (b.lane || 9999));
    }
}
